//Innyx Component
import {
  InputCustom,
  InputSelect,
  InputSelectSearch,
  InputDate,
  GradeEdicao,
  MunicipioUf,
  CustomFilterButton,
  TabelaAccordion,
  Tabela,
  TabelaInput,
  Paginacao,
} from "./components";

import InputSelect2 from "./components/Inputs/InputSelect/InputSelect2.vue";
import BotaoCadastrar from "./components/Botoes/BotaoCadastrar.vue";

export default (app) => {
  const components = {
    InputCustom,
    InputSelect,
    InputSelectSearch,
    InputDate,
    GradeEdicao,
    MunicipioUf,
    CustomFilterButton,
    TabelaAccordion,
    Tabela,
    TabelaInput,
    Paginacao,
    BotaoCadastrar,
    InputSelect2,
  };

  Object.entries(components).forEach(([name, component]) =>
    app.component(name, component)
  );
};
